"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.ImageContiner = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _inlines = require("@canner/slate-constant/lib/inlines");

var _slateIconShared = require("@canner/slate-icon-shared");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  src: ", ";\n  width: ", ";\n  height: ", ";\n  margin-left: ", ";\n  display: flex;\n  justify-content: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ImageContiner = _styledComponents.default.img(_templateObject(), function (props) {
  return props.src;
}, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.indent;
}, function (props) {
  if (props.align === "center") return "center";else if (props.align === "right") return "flex-end";
  return "flex-start";
});

exports.ImageContiner = ImageContiner;

var defaultAttrs = _objectSpread({
  src: function src(node) {
    return node.data.get("src");
  }
}, _slateIconShared.nodeAttrs);

function _default() {
  var inlineType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _inlines.IMAGE;
  var stylesAttr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultAttrs;
  return {
    deserialize: function deserialize(el) {
      if (inlineType && el.tagName && el.tagName.toLowerCase() === "img") {
        var data = {};

        if (el.src) {
          data.src = el.src;
        }

        if (el.style.marginLeft) {
          data.indent = el.style.marginLeft;
        }

        if (el.style.width && typeof el.style.width === "number" && el.style.width > 0) {
          data.width = el.style.width;
        }

        if (el.style.height && typeof el.style.height === "number" && el.style.height > 0) {
          data.height = el.style.height;
        }

        return {
          object: "inline",
          type: inlineType,
          data: data,
          isVoid: true
        };
      }
    },
    serialize: function serialize(obj) {
      if (obj.object == "inline" && obj.type === inlineType) {
        var align = stylesAttr.textAlign(obj);
        var indent = stylesAttr.paddingLeft(obj);
        var src = stylesAttr.src(obj);
        var width = stylesAttr.width(obj);
        var height = stylesAttr.height(obj);
        return _react.default.createElement(ImageContiner, {
          align: align,
          width: width,
          height: height,
          indent: indent,
          src: src
        });
      }
    }
  };
}